import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Chatbot } from "@/components/Chatbot";
import { NewsTicker } from "@/components/NewsTicker";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import CalendarPage from "@/pages/CalendarPage";
import SearchPage from "@/pages/SearchPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import CompanyDashboard from "@/pages/CompanyDashboard";
import CompanyPublicProfile from "@/pages/CompanyPublicProfile";
import UltraAdmin from "@/pages/UltraAdmin";
import OrgAuthPage from "@/pages/OrgAuthPage";
import OrgDashboard from "@/pages/OrgDashboard";
import OrgPublicProfile from "@/pages/OrgPublicProfile";
import FreelancerAuthPage from "@/pages/FreelancerAuthPage";
import FreelancerDashboard from "@/pages/FreelancerDashboard";
import FreelancerPublicProfile from "@/pages/FreelancerPublicProfile";
import SupplierAuthPage from "@/pages/SupplierAuthPage";
import SupplierDashboard from "@/pages/SupplierDashboard";
import SupplierPublicProfile from "@/pages/SupplierPublicProfile";
import SuppliersListPage from "@/pages/SuppliersListPage";
import CompaniesListPage from "@/pages/CompaniesListPage";
import OrganizersListPage from "@/pages/OrganizersListPage";
import FreelancersListPage from "@/pages/FreelancersListPage";
import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [tickerArticles, setTickerArticles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/articles?limit=8`).then((r) => setTickerArticles(r.data)).catch(() => {});
  }, []);

  const isAdmin = window.location.pathname === "/ultra-admin";

  return (
    <div className={isAdmin ? "" : "paper-noise min-h-screen bg-[#FAFAF9]"}>
      <BrowserRouter>
        {!isAdmin && <Navbar />}
        {!isAdmin && <NewsTicker articles={tickerArticles} />}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/haber/:id" element={<ArticlePage />} />
            <Route path="/takvim" element={<CalendarPage />} />
            <Route path="/arama" element={<SearchPage />} />
            <Route path="/giris" element={<LoginPage />} />
            <Route path="/kayit" element={<RegisterPage />} />
            <Route path="/panel" element={<CompanyDashboard />} />
            <Route path="/firma/:slug" element={<CompanyPublicProfile />} />
            <Route path="/ultra-admin" element={<UltraAdmin />} />
            <Route path="/organizator-giris" element={<OrgAuthPage />} />
            <Route path="/organizator-panel" element={<OrgDashboard />} />
            <Route path="/organizator/:slug" element={<OrgPublicProfile />} />
            {/* Freelancer Routes */}
            <Route path="/freelancer-giris" element={<FreelancerAuthPage />} />
            <Route path="/freelancer-panel" element={<FreelancerDashboard />} />
            <Route path="/freelancer/:slug" element={<FreelancerPublicProfile />} />
            {/* Supplier/Tedarikçi Routes */}
            <Route path="/tedarikci-giris" element={<SupplierAuthPage />} />
            <Route path="/tedarikci-panel" element={<SupplierDashboard />} />
            <Route path="/tedarikci/:slug" element={<SupplierPublicProfile />} />
            {/* List Pages */}
            <Route path="/tedarikciler" element={<SuppliersListPage />} />
            <Route path="/firmalar" element={<CompaniesListPage />} />
            <Route path="/organizatorler" element={<OrganizersListPage />} />
            <Route path="/freelancerlar" element={<FreelancersListPage />} />
          </Routes>
        </main>
        {!isAdmin && <Footer />}
        {!isAdmin && <Chatbot />}
        <Toaster position="bottom-left" />
      </BrowserRouter>
    </div>
  );
}

export default App;
